
import React, { memo, useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button, CircularProgress } from '@mui/material';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectTrimData } from '../Selectors/StitchSelector/StitchingSelectors';
import { fetchTrimmingReg, TrimmingInwardEntry } from '../../Store/PHPSlice/Trimming/TrimApi';


const TrimInward = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        trId: Id,
        dt: getCurrentDate(),
        empNm: '',
        empId: '',
        ordType: '',
        soId: '',
        sono: '',
        userId: userdata?.ID
    });
    const dispatch = useDispatch();
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [usedTotMtr, setUsedTotMtr] = useState(0);
    const [balTotMtr, setBalTotMtr] = useState(0);
    const [baleNo, setBaleNo] = useState('');

    const [inwardData, setInwardData] = useState([]);

    const [loading, setLoading] = useState(false);

    const trimlist = useSelector(selectTrimData);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        dispatch(fetchTrimmingReg(Id));
        // console.log(Id);
    }, [Id, dispatch]);


    // console.log(trimlist);

    useEffect(() => {
        if (trimlist?.data) {
            const item = trimlist.data;
            const inwMemo = trimlist.countId > 0 ? `R-${item.trMemo}-${parseFloat(trimlist.countId) + 1}` : `R-${item.trMemo}-1`;
            setFormData(prev => ({
                ...prev,
                memo: inwMemo,
                dt: item?.dt,
                soId: item?.soId,
                sono: item?.sono,
                empId: item?.empId,
                empNm: item?.empNm,
                itemId: item?.itemId,
                itemNm: item?.itemNm,
                mcloth: item?.mcloth,
                mclothNm: item?.mclothNm,
                m1cloth: item?.m1cloth,
                m1clothNm: item?.m1clothNm,
                m2cloth: item?.m2cloth,
                m2clothNm: item?.m2clothNm,
                m3cloth: item?.m3cloth,
                m3clothNm: item?.m3clothNm,
                totqty: item?.totqty,
                sts: item?.sts,
                firmId: item?.firmId,
                firmNm: item?.firmNm
            }));
            setInwardData(trimlist?.info);
        }
    }, [trimlist]);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleQtyChange = (index, e) => {
        const value = parseInt(e.target.value || 0, 10);
        const updated = inwardData?.map((item, i) =>
            i === index ? {
                ...item, inwqty: value <= item.balqty ? value : item.balqty,
                bqty: value <= item.balqty ? parseFloat(item.balqty) - value : 0
            } : item
        );

        if (value <= inwardData[index].balqty) {
            setInwardData(updated);
        } else {
            alert("Inward Qty cannot be greater than Remaining Qty.");
        }
    };

    function postObj(formData, inwardData) {
        const totqty = inwardData?.reduce((acc, sum) => acc + parseFloat(sum.balqty), 0);
        const reqty = inwardData?.reduce((acc, sum) => acc + parseFloat(sum.inwqty), 0);
        return {
            dt: formData.dt,
            trId: formData.trId,
            trnMemo: formData.memo,
            empId: formData.empId,
            firmId: formData.firmId,
            itemId: formData.itemId,
            totqty: totqty,
            reqty: reqty,
            userId: formData.userId,
            soId: formData.soId,
            inwardData: inwardData
        };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const obj = postObj(formData, inwardData);
            // console.log("Submitting:", obj);

            const result = await dispatch(TrimmingInwardEntry(obj)).unwrap();
            console.log('POST request successful!', result);
            alert("Trimming Inward successfully");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    }

    const fields = [
        { name: 'dt', type: 'date' }
    ];

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Trimming Inward Entry</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }}>
                                        {/* <input
                                            type="date"
                                            value={new Date().toISOString().split('T')[0]}
                                            max={new Date().toISOString().split('T')[0]}
                                            style={{ width: '100%' }}
                                        /> */}
                                        {fields.map((field) => (
                                            <DateInputComponent
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                            />
                                        ))}
                                    </td>
                                    <td style={{ width: '200px' }}>Kaje Inward No.</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.memo}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Employee</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>




                                <tr>
                                    <td style={{ width: '200px' }}>SO No.</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.sono}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.itemNm}</td>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.mclothNm}</td>
                                </tr>

                                <tr>
                                    <td>M1 Cloth</td>

                                    <td>{formData.m1clothNm || '-'}</td>
                                    <td>M2 Cloth</td>

                                    <td>{formData.m2clothNm || '-'}</td>
                                </tr>
                                <tr>
                                    <td>M3 Cloth</td>

                                    <td>{formData.m3clothNm || '-'}</td>
                                </tr>
                            </tbody>


                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Issue Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Remaining Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Inward Qty.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(inwardData) && inwardData.length > 0 ? (
                                        inwardData?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.balqty}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.bqty}</TableCell>
                                                <TableCell
                                                    key={index}
                                                    sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                    align='center'
                                                >
                                                    <input
                                                        type="text"
                                                        value={item.inwqty || 0}
                                                        onChange={(e) => handleQtyChange(index, e)}
                                                        style={{ width: '80px', padding: '1px' }}
                                                    />
                                                </TableCell>

                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align='center'>No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>

                        </TableContainer>
                        <Grid item xs={12} textAlign="center">
                            <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                {
                                    loading === true ?
                                        <><CircularProgress size="20px" /> wait...</> :
                                        "Submit"
                                }
                            </Button>
                        </Grid>
                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default TrimInward;
